import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import { restoreActionInfo, saveSelectedUsers } from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import { sync as syncUsers } from '@app/actions/users/memberList'
import SelectNotificationUser
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/Notifications/SelectNotificationUser/SelectNotificationUser'
import SelectNotificationUserIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/Notifications/SelectNotificationUser/SelectNotificationUser'
import {
  withAccessDenied, withNotifications, withProgressAndErrorMessage, withRefresh, withRouter,
} from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectNotificationUserIOS) : withStyles(SelectNotificationUser)

const mapStateToProps = (state) => {
  const { selectedUsers } = state.scenes.currentSceneCreating.currentAction
  const { users } = state.users.memberList
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  return {
    selectedUsers,
    users,
    isMobile,
    path,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
    inProgress: state.apiRequest.inProgress,
    errorMessage: state.apiRequest.errorMessage,
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  refresh: syncUsers,
  tryAgain: syncUsers,
  saveSelectedUsers,
  restoreActionInfo,
  notifications: syncNotifications.sync,
}, dispatch)

enhance = withRefresh(enhance)
enhance = withProgressAndErrorMessage(enhance)
enhance = withNotifications(enhance)
enhance = withAccessDenied(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectNotificationUserEnhanced = enhance

export default withRouter(SelectNotificationUserEnhanced)
